import VueLocalForage from 'vue-localforage'
import firebase from 'firebase/compat/app'
import 'firebase/compat/auth'
import 'firebase/compat/firestore'
import 'firebase/compat/storage'
import { getFirebaseApp, firebaseConfig } from '@/infra/firebase/app'
import { createGoogleAuthProvider } from '@/infra/firebase/auth'
import { createFirestorePaths } from '@/services/firebase/constants'
import { authMethods } from '@/services/firebase/authMethods'
import { backupMethods } from '@/services/firebase/backupMethods'
import { userDataMethods } from '@/services/firebase/userDataMethods'
import { wireAuthLifecycle } from '@/services/firebase/authLifecycle'

// compat leftover (`firebase.auth` / `firestore` / `storage`) 用に DEFAULT を載せる
getFirebaseApp()

if (process.env.NODE_ENV === 'development') {
  console.log('firebaseConfig', firebaseConfig)
}

let firebaseClient = null
export const getFirebaseClient = () => firebaseClient

const FirebaseLib = {
  install: function (Vue, _options) {
    Vue.use(VueLocalForage)
    const main = new Vue({
      data: function () {
        return {
          accessToken: '',
          db: {},
          user: null,
          userConfig: {},
          lastBackupSaveDate: null,
          lastLocalSaveDate: null,
          autoBackupTimer: null,
          isAddingBackupNow: false,
          isLoginAction: false
        }
      },
      computed: {
        config: function () {
          return firebaseConfig
        },
        storage: function () {
          // Compat Storage keeps .ref().child().put() for YagiFriends callers
          return firebase.storage()
        },
        authProviderGoogle: function () {
          return createGoogleAuthProvider()
        },
        isAuthenticated: function () {
          if (this.user && this.user.uid) {
            return true
          } else {
            return false
          }
        },
        firestorePaths: function () {
          if (!this.user || !this.user.uid) {
            return
          }
          return createFirestorePaths(this.user.uid)
        },
        backupStatus: function () {
          if (this.isAddingBackupNow) {
            return {
              type: 'now',
              message: '現在バックアップ中です'
            }
          } else if (this.lastBackupSaveDate) {
            return {
              type: 'done',
              message: this.lastBackupSaveDate
            }
          } else {
            return {
              type: 'none',
              message: ''
            }
          }
        }
      },
      methods: {
        ...authMethods,
        ...backupMethods,
        ...userDataMethods,
        /**
         * External callers (Friends / MyPage) still use namespaced `db.collection` /
         * `db.doc`. Keep compat Firestore on `this.db` while core methods use modular.
         */
        setupDb: function () {
          this.db = firebase.firestore()
        },
        init: function () {
          this.setupDb()
          this.loadUserConfig()
          this.activateAutoBackup()
          this.alertIfNeedsLoadingBackup()
          this.updateUserDocTimestamp()
          this.$eventHub.$emit('mailmaga-flag-initialized', this.user)
          this.$eventHub.$emit('yagioffer-flag-initialized', this.user)
          this.$eventHub.$emit('fontpayment-flag-initialized', this.user)
          this.$eventHub.$emit('yagioffer-regist-update', this.user)
        }
      }
    })

    wireAuthLifecycle(main)

    firebaseClient = main
    Vue.prototype.$firebase = main
  }
}
export default FirebaseLib
